
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Instrumental Sitar </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm bhupaal-panshikar section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
			<h2>Instrumental  <span > Sitar  </span></h2>
		</div>
        <div class="row">
            <div class="col-lg-8">
                <div class=" text-justify">
                    <h2 class="head-lea">Shri. Bhupal Panshikar <span class="small-sm">05<sup>th</sup> April 2019
                        </span></h2>
                </div>
                <p>
                    Bhupal is a Sitar player and singer, composer Bhupal Panshikar is a singular figure in Indian
                    Classical music Diasporas whose eminent style of sitar playing has regaled audiences in India and
                    abroad.
                </p>
                <p>
                    Coming from a family of Sanskrit literature stalwarts, drama, and music personalities young Bhupal
                    chose to study music at the tender age of 10 under his father and guru pt.Dinkar Panshikar (living
                    legend of Jaipur gharana)
                    Bhupal really has a gifted musical persona right from childhood resulting, he enacted in the
                    fabulous Marathi musical play katyar kaljat Ghusli as a child artist way back in 1983-84.

                </p>
                <p> In his early teens Bhupal started learning sitar from Bharat Ratna lt Pt.Ravishankar ji in Delhi and
                    then padmabhushan pt.Arvind Parikh (well-known maestro of vilayatkhani gharana) and till the date
                    receiving training from him.</p>

            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupaal-panshikar1.webp"
                        alt="GHRSCF">
                </div>
            </div>
            <div class="col-md-12 mt-3">
                <p>

                    A quest for more musical knowledge made him more studious towards vocal tradition of north Indian
                    Music (stylistic singing) and studied under lt.pt.chandrashekhar rele a well-known associate and
                    gurubandhu of lt.pt.kumar gandharwa of Gwalior gharana.
                    Simultaneously Bhupal’s sitar is influenced by his own vocal training and a tremendous impact of
                    vocal phrases woven in his playing resulting it going beyond sheer tonal music.

                </p>
                <p>
                    Bhupal is a composer and music arranger and has worked with many Bollywood composers and has been
                    actively playing sitar for film industry, daily soap operas, and Back Ground Music scores for
                    various titles.
                    His first solo album Raga Sangraha 1 & 2 successfully captured music lovers in 2010
                </p>
            </div>
            <div class="col-lg-8">
                <div class="widget_title inner-title">
                    <h4>Main composer of Soul Curry flamenco and jazz fusion band</h4>
                </div>
                <ul class="list-style list-style1">
                    <li>Pan IIT Global Leadership Summit –California –USA2015</li>
                    <li>Prathswar –innitiative by Panchamnishad creatives –Mumbai2016</li>
                    <li>Saptak – Nasik2007</li>
                    <li>Indian music Festival- Germany and Hongkong2005</li>
                    <li>Indian music fest strings and tones –USA 2017</li>
                    <li>Potpourri international ensemble –Singapore Feb. 2018</li>
                    <li>Gaan Prabha mahotsav Mumbai2017</li>
                    <li>Suburban music circle Mumbai2016</li>
                    <li>Jitendra abhisheki mahotsav pune 2014</li>
                    <li>Singapore Art Festival 2018</li>
                </ul>
            </div>
            <div class="col-md-4">
                <div class=" text-justify">
                    <h2 class="head-lea">Invitation</h2>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-1">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/invitation_bhupal.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/invitation_bhupal.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/invitation_bhupal.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <p>Artist : Shri. Bhupal Panshikar</p>
            <p>Tabla Artist : Shri. Sandesh Popatkar</p>
            <p>Date : 05<sup>th</sup> April 2019</p>
            <p>Time : 7.00 Pm</p>
            <p>Venue : Chitnavis Centre, Besides Hislop College, Civil Lines, Nagpur</p>
        </div>
        <div class="border-line-sm"></div>
        <div class="row row-cols-1 row-cols-md-3">
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Media Coverage</h4>
                        </div>
                    </div>
                    <div>
                        <iframe style="width: 100%; height: 230px;"
                            src="https://drive.google.com/file/d/1Lai3_2hssY-RDtzss9JT1mztpPDXmfKO/preview?"></iframe>
                    </div>
                </div>

            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Videos</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>

                </div>
                <iframe width="100%" height="230px" src="https://www.youtube.com/embed/ZHzIPevE4bA" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Photos</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="photogallery#aditi-upadhya" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupal_1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupal_1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupal_1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupal_2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupal_2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupal_2.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupal_3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupal_3.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupal_3.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupal_4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupal_4.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupal_4.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupal_5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupal_5.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupal_5.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupal_6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupal_6.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupal_6.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>

            </div>



        </div>
    </div>

</section>
